import PROMISED_PAYMENT_API from 'api/promised-payment/v1'
import { startSubmit, SubmissionError } from 'redux-form'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'
import {
  CREATE_PROMISED_PAYMENT_REQUEST,
  FETCH_PROMISED_PAYMENT_SETTINGS,
  SET_PROMISED_PAYMENT_DATA,
  FETCH_PROMISED_PAYMENT,
  SET_PROMISED_PAYMENT_SETTINGS,
  FETCH_TAKEN_PROMISED_PAYMENT,
  SET_TAKEN_PROMISED_PAYMENT_DATA,
} from 'modules/Finance/PromisedPayment/store/types'
import { cancellableCall } from 'store/saga-utils/cancellableCall.saga'

function* fetchSettings() {
  try {
    yield put({
      type: SET_PROMISED_PAYMENT_SETTINGS,
      payload: { loading: true },
    })

    const { response, error } = yield call(PROMISED_PAYMENT_API.fetchSettings)

    if (error) {
      throw error
    }

    yield put({
      type: SET_PROMISED_PAYMENT_SETTINGS,
      payload: {
        ...response.data,
      },
    })
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    yield put({
      type: SET_PROMISED_PAYMENT_SETTINGS,
      payload: {
        failed: true,
      },
    })
    console.logXHR(error)
  } finally {
    yield put({
      type: SET_PROMISED_PAYMENT_SETTINGS,
      payload: {
        loaded: true,
        loading: false,
      },
    })
  }
}

function* createRequest({ payload, formName }) {
  const { meta: { resolve = () => {}, reject = () => {} } = {}, ...rest } = payload
  try {
    yield put(startSubmit(formName))

    const { error } = yield call(PROMISED_PAYMENT_API.create, {
      data: { ...rest },
    })

    if (error) {
      throw error
    }

    yield put(
      notificationShow({
        type: 'success',
        message: 'promised_payment::notifications.request_successfully_created',
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors)

    reject(fields ? new SubmissionError(fields) : error.statusText)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form || 'promised_payment::notifications.request_creation_failed',
          delay: 10000,
        }),
      )
    } else {
      yield put(
        notificationShow({
          type: 'error',
          message: form || 'common::notifications.unexpected_error',
        }),
      )
    }
  }
}

export function* fetchPromisedPayment({ payload }) {
  const { promisedPayment: { data: promisedPayment = [] } = {} } = yield select(
    (state) => state['finance/promised-payment'],
  )

  try {
    yield put({
      type: SET_PROMISED_PAYMENT_DATA,
      payload: {
        loading: true,
      },
    })

    const { response, error } = yield cancellableCall(
      PROMISED_PAYMENT_API.fetchAll,
      {
        params: {
          ...payload,
        },
      },
      arguments,
    )

    if (error) {
      throw error
    }

    const { data = [], pagination = {} } = response

    yield put({
      type: SET_PROMISED_PAYMENT_DATA,
      payload: {
        data: [...promisedPayment, ...data],
        pagination,
      },
    })
  } catch (error) {
    yield put({
      type: SET_PROMISED_PAYMENT_DATA,
      payload: { failed: true },
    })

    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: SET_PROMISED_PAYMENT_DATA,
      payload: {
        loaded: true,
        loading: false,
      },
    })
  }
}

export function* fetchTakenPromisedPayment() {
  try {
    yield put({
      type: SET_TAKEN_PROMISED_PAYMENT_DATA,
      payload: {
        loading: true,
      },
    })

    const { response, error } = yield call(PROMISED_PAYMENT_API.fetchAll, {
      params: {
        statuses: ['pending', 'approved'],
      },
    })

    if (error) {
      throw error
    }

    const { data = [] } = response

    yield put({
      type: SET_TAKEN_PROMISED_PAYMENT_DATA,
      payload: {
        data,
      },
    })
  } catch (error) {
    yield put({
      type: SET_TAKEN_PROMISED_PAYMENT_DATA,
      payload: {
        failed: true,
      },
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: SET_TAKEN_PROMISED_PAYMENT_DATA,
      payload: {
        loaded: true,
        loading: false,
      },
    })
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH_PROMISED_PAYMENT_SETTINGS, fetchSettings)
  yield takeLatest(CREATE_PROMISED_PAYMENT_REQUEST, createRequest)
  yield takeLatest(FETCH_PROMISED_PAYMENT, fetchPromisedPayment)
  yield takeLatest(FETCH_TAKEN_PROMISED_PAYMENT, fetchTakenPromisedPayment)
}
